"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _DialogHeader = _interopRequireDefault(require("./atoms/DialogHeader"));

var _DialogBody = _interopRequireDefault(require("./atoms/DialogBody"));

var _DialogFooter = _interopRequireDefault(require("./atoms/DialogFooter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      type = _ref.type,
      buttons = _ref.buttons,
      rest = _objectWithoutProperties(_ref, ["children", "onClose", "type", "buttons"]);

  return _react["default"].createElement(_Modal["default"], rest, _react["default"].createElement(_DialogHeader["default"], {
    onClose: onClose,
    type: type
  }), _react["default"].createElement(_DialogBody["default"], null, children), _react["default"].createElement(_DialogFooter["default"], {
    buttons: buttons
  }));
};

Dialog.defaultProps = {
  width: 448,
  open: false,
  onClose: function onClose() {},
  type: 'none',
  buttons: [{
    label: 'Ok',
    variant: 'contained',
    color: 'secondary',
    callback: function callback() {}
  }]
};
Dialog.propTypes = {
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  open: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  type: _propTypes["default"].oneOf(['success', 'error', 'none']),
  buttons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    variant: _propTypes["default"].oneOf(['contained', 'text']),
    color: _propTypes["default"].oneOf(['secondary', 'primary', 'default']),
    callback: _propTypes["default"].func
  }))
};
var _default = Dialog;
exports["default"] = _default;